export function validateEmail(email) {
  // copy/paste from StackOverflow, because the syntax for valid email addresses is VERY complex
  // https://stackoverflow.com/questions/201323/how-can-i-validate-an-email-address-using-a-regular-expression

  // note that a simpler regex, such as the one here (https://stackoverflow.com/questions/5601647/html5-email-input-pattern-attribute/65442112#65442112)
  // doesn't properly allow some valid emails, such as the one below

  // example real-world email that is in our system: "st.-anns@cdolinc.net" (https://stannsdoniphan.flocknote.com/dashboard/user/21949005)

  // eslint-disable-next-line
  const re =
    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
  return re.test(email);
}
